import {
  PageComponent,
  PageOption,
} from "../constants/page-components.mapping";
import usePageComponents from "./page-components.hook";

export default function useRenderPageComponent<P extends PageOption>({
  page,
  component,
  trackTypeId,
}: {
  page: P;
  component: PageComponent<P>;
  trackTypeId?: number;
}) {
  const { data: pageComponents, isLoading } = usePageComponents({
    page,
    trackTypeId,
  });

  const renderedComponent = pageComponents?.data?.find(
    (item) => item.name === component,
  );

  return {
    isLoading,
    renderedComponent,
  };
}
